import { createFileRoute, redirect } from '@tanstack/react-router'

/** /payroll: the runs are payroll's home. */
export const Route = createFileRoute('/_app/payroll/')({
  beforeLoad: () => {
    throw redirect({ to: '/payroll/runs', replace: true })
  },
})
